module.exports = __webpack_public_path__ + "static/media/icons_Bilan Guillarme - Pré partum.a4ef786f.svg";